var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3881_3650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9609 5.75398C14.8627 5.45024 14.5933 5.23452 14.2746 5.20579L9.94517 4.81268L8.2332 0.805654C8.10697 0.511991 7.81949 0.321899 7.50008 0.321899C7.18066 0.321899 6.89318 0.511991 6.76695 0.80634L5.05498 4.81268L0.724885 5.20579C0.406732 5.2352 0.138017 5.45024 0.0392524 5.75398C-0.0595127 6.05771 0.0316991 6.39086 0.272374 6.60086L3.5449 9.47088L2.57991 13.7217C2.50929 14.0342 2.6306 14.3573 2.88993 14.5448C3.02933 14.6455 3.19241 14.6967 3.35687 14.6967C3.49866 14.6967 3.63931 14.6585 3.76554 14.583L7.50008 12.351L11.2332 14.583C11.5064 14.7473 11.8508 14.7323 12.1095 14.5448C12.369 14.3567 12.4902 14.0335 12.4196 13.7217L11.4546 9.47088L14.7271 6.60143C14.9678 6.39086 15.0597 6.05828 14.9609 5.75398Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3881_3650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f928a47c066b14c91659f3f2c2983948.svg";
export { ForwardRef as ReactComponent };